import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';

/**
 * Floating bulk-action bar that appears once one or more orders are
 * selected. Action buttons disable themselves when the current
 * selection's mixed status would make the action invalid.
 */
export default function BulkActionToolbar({
  selectedCount,
  canBulk,
  busy,
  onRun,
  onClear,
}) {
  if (selectedCount === 0) return null;
  return (
    <Stack
      direction='row'
      alignItems='center'
      flexWrap='wrap'
      gap='10px'
      sx={{ mb: '10px', p: '10px', borderRadius: '10px', bgcolor: 'info.light' }}
    >
      <Typography variant='body2' fontWeight='600'>
        {selectedCount} selected
      </Typography>
      <Box flex='1' />
      <Button
        size='small'
        variant='contained'
        color='success'
        disabled={!canBulk('mark-paid') || busy}
        onClick={() => onRun('mark-paid')}
      >
        Mark paid
      </Button>
      <Button
        size='small'
        variant='contained'
        disabled={!canBulk('fulfill') || busy}
        onClick={() => onRun('fulfill')}
      >
        Mark fulfilled
      </Button>
      <Button
        size='small'
        variant='outlined'
        color='error'
        disabled={!canBulk('cancel') || busy}
        onClick={() => onRun('cancel')}
      >
        Cancel
      </Button>
      <Button size='small' onClick={onClear}>Clear</Button>
    </Stack>
  );
}
